<template>
  <div
    class="page-engine-displacement"
    :class="is_from_ai ? 'ai-custom-pb' : ''"
  >
    <!-- AI识车后的结果 -->
    <!-- <div v-if="is_from_ai" class="top-bg"></div> -->
    <div v-if="is_from_ai" class="vehicle-content">
      <div class="vehicle-box">
        <div class="vehicle-bg">
          <img class="vehicle-img" :src="cache_photo" />
        </div>
      </div>
      <div class="tip-info">根据您的照片匹配的车型如下：</div>
      <div class="error-info">
        *若匹配出的车型与实际不符，可尝试换角度拍摄识别，或返回首页拍摄VIN码进行识别
      </div>
      <div v-if="engine_displacements.length" class="vehicle-info">
        <img class="vehicle-icon" :src="brand_logo_url" />
        <div class="info-box">
          <div
            :class="{ 'vehicle-name': true, 'blue-color': is_new_energy == 1 }"
          >
            {{ vehicle_name }}
          </div>
          <div class="vegicle-code">
            车牌号：{{
              license_plate ? decodeURIComponent(license_plate) : "--"
            }}
          </div>
        </div>
      </div>
      <div v-else class="vehicle-empty">
        <img
          class="empty-img"
          src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/unknown_vehicle.png"
        />
        <div class="txt">未识别出车型</div>
      </div>
    </div>
    <!-- 正常选择的车型 -->
    <div v-else class="selected-vehicle-name">
      <img
        class="logo"
        :src="
          brand_logo_url ||
          'https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/default_car_logo.png'
        "
      />
      {{ vehicle_name }}
    </div>
    <!-- 可供选择的排量列表 -->
    <div v-if="engine_displacements.length" class="engine-displacement-list">
      <div class="subtitle">
        <img
          v-if="is_new_energy == 1"
          class="rect-icon"
          src="@/assets/maintain/square_fold_blue.png"
        />
        <img v-else class="rect-icon" src="@/assets/maintain/square_fold.png" />
        <div
          class="subtitle-text"
          :class="is_new_energy == 1 ? 'blue-color' : ''"
        >
          请选择发动机排量
        </div>
      </div>
      <div
        class="engine-displacement-item"
        @click="toSelectVehicle(item)"
        v-for="(item, index) in engine_displacements"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <!-- AI识别车辆后的操作按钮 -->
    <div v-if="is_from_ai" class="footer-box">
      <!-- 微信环境，调用微信上传 -->
      <div class="btn-l" v-if="iswx == 1" @click="photographAndIdentify">
        去拍摄
      </div>
      <!-- H5环境，使用原生上传 -->
      <van-uploader
        v-else
        :after-read="afterRead"
        capture="camera"
        accept="image/*"
      >
        <div class="btn-l">重新拍摄识别</div>
      </van-uploader>
      <div class="btn-r" @click="goSelectPage">手动选择车型</div>
    </div>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api.js";
import wx from "weixin-js-sdk";
import { Uploader } from "vant";
import { compressImg } from "@/utils/tools.js";
import { wxShare } from "@/plugins/WxConfig.js";
export default {
  name: "engine-displacement",
  components: { VanUploader: Uploader },
  data() {
    return {
      vehicle_name: "",
      engine_displacements: [],
      is_new_energy: "", // 是否为新能源
      is_from_ai: false, // 是否从AI识图页面跳转过来的
      cache_photo: "",
      brand_logo_url: "",
      license_plate: "",
      temp_query: null,
      iswx: this.browser.wx, // 是否是微信环境，
    };
  },
  mounted() {
    // 如果车型信息在缓存中存在，则说明用户重新拍照识别车型，车型信息并不是query中的参数，从缓存中获取并初始化
    const cacheQuery = sessionStorage.getItem("cacheQuery");
    let query = this.$route.query; //默认取route中的query
    if (this.$route.query.internal_from === "ai_photo" && cacheQuery) {
      query = JSON.parse(cacheQuery); // 缓存存在则取缓存中的query
    }
    this.temp_query = query;
    this.initData();
    this.init(query);
    wxShare();
  },
  methods: {
    init(query) {
      const {
        brand_name,
        factory_name,
        model_alias,
        brand_logo_url,
        license_plate,
      } = query;
      this.license_plate = license_plate;
      this.cache_photo = sessionStorage.getItem("current_photo_base64");
      this.vehicle_name = `${brand_name} - ${factory_name} - ${model_alias}`;
      this.brand_logo_url = brand_logo_url;
      this.is_from_ai = this.$route.query.internal_from === "ai_photo";
      this.is_new_energy = this.$route.query.is_new_energy;
      this.fetchDisplacementList(query);
    },
    /**
     * 识别图片 & 存储图片base64到本地
     * @param {*} file
     */
    async afterRead(file) {
      console.log(file);
      sessionStorage.removeItem("cacheQuery");
      const result = await compressImg(file.file, 0.7);
      if (file.content) {
        result.content = file.content;
      }
      console.log("照片信息", result);
      const formData = new FormData();
      formData.append("file", result.file);
      try {
        this.$loading.show("加载中...");
        const res = await api.identifyVehicleByPhotoApi(formData);
        if (res.code == 0) {
          this.$loading.hide();
          console.log("识别结果", res);
          this.temp_query = res.data;
          // 重新拍照识别后缓存拍照信息及当前识别的结果
          sessionStorage.removeItem("current_photo_base64");
          sessionStorage.setItem(
            "current_photo_base64",
            result.afterSrc || result.content
          );
          sessionStorage.setItem("cacheQuery", JSON.stringify(this.temp_query));
          // 更新车牌和是否新能源标识以更新页面
          this.license_plate = res.data.license_plate;
          this.is_new_energy = res.data.is_new_energy;
          this.init(this.temp_query); //根据新识别的车型结果重新查询排量列表
        } else {
          this.$loading.hide();
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        error && console.log("上传图片异常", error);
      }
    },
    /**
     * 点击排量跳转年份、款型选择页面
     * @param {string} displacement
     */
    toSelectVehicle(displacement) {
      const query =
        this.temp_query && this.temp_query.brand_name
          ? this.temp_query
          : this.$route.query;
      const {
        brand_name,
        factory_name,
        model_alias,
        license_plate,
        brand_logo_url,
      } = query;
      this.$router.push({
        name: "years-sale-names",
        query: {
          brand_name,
          factory_name,
          model_alias,
          displacement,
          // brand_logo_url: encodeURIComponent(this.$route.query.brand_logo_url),
          license_plate: license_plate || this.$route.query.license_plate,
          brand_logo_url: brand_logo_url,
          scheme_id: this.$route.query.scheme_id,
          internal_from: this.$route.query.internal_from,
          is_new_energy: this.is_new_energy,
        },
      });
    },
    /**
     * 获取发动机排量列表
     */
    async fetchDisplacementList(query) {
      if (!query.brand_name) return;
      this.$loading.show("加载中...");
      try {
        const { brand_name, factory_name, model_alias } = query;
        const res = await api.getDisplacementListApi({
          brand_name,
          factory_name,
          model_alias,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.engine_displacements = res.data;
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        console.log("获取发动机排量列表失败！");
        error && console.log(error);
      }
    },
    /**
     * 重新拍摄识别
     */
    takePhotos() {
      sessionStorage.againPhoto = true;
      this.$router.go(-1);
    },
    /**
     * 拍照识别车型
     */
    photographAndIdentify() {
      let self = this;
      wx.chooseImage({
        count: 1,
        sizeType: ["compressed"],
        sourceType: ["camera"],
        success: function (res) {
          console.log(233, res);
          let id = res.localIds[0];
          // self.$loading.show("识别中...");
          wx.getLocalImgData({
            localId: id,
            success: function (res) {
              let localData = res.localData;
              if (localData.indexOf("data:image") != 0) {
                //判断是否有这样的头部
                localData = "data:image/jpeg;base64," + localData;
              }
              localData = localData
                .replace(/\r|\n/g, "")
                .replace("data:image/jgp", "data:image/jpeg");
              const file = self.base64ToFile(localData);
              console.log(file);
              self.afterRead({ file: file, content: localData });
            },
          });
        },
        fail(err) {
          console.log("err", err);
        },
      });
    },
    base64ToFile(base64) {
      try {
        let bstr = null;
        let n = null;
        let u8arr = null;
        let mime = base64.split(",")[0].match(/:(.*?);/)[1] //mime类型 image/png
        if (base64.indexOf(",") > 0) {
          //  ios兼容
          let arr = base64.split(",");
          bstr = atob(arr[1]);
        } else {
          bstr = atob(base64);
        }
        n = bstr.length;
        u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File([u8arr], `select_oil_${new Date().getTime()}.${mime.split("/")[1]}`, { type: mime })
        return file;
      } catch (err) {
        console.error("异常", err);
        return null;
      }
    },
    /**
     * 初始化数据：版本信息、分享配置
     */
    async initData() {
      if (
        !window.sessionStorage.getItem("OILSHARE") &&
        (this.$route.query.scheme_id || this.$route.query.id)
      ) {
        const res = await api.getShareApi({
          scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          window.sessionStorage.setItem("OILSHARE", JSON.stringify(res.data));
          // this.app_icon = res.data.h5_logo;
          // this.app_name = res.data.name;
        } else {
          console.error("数据统计失败", res.message);
        }
      } else if (window.sessionStorage.getItem("OILSHARE")) {
        // const obj = JSON.parse(window.sessionStorage.getItem("OILSHARE"));
        // this.app_icon = obj.h5_logo;
        // this.app_name = obj.name;
      }
    },
    /**
     * 手动选择车型
     */
    goSelectPage() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page-engine-displacement {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  position: relative;
  .selected-vehicle-name {
    // margin: 27/100rem 17/100rem;
    color: #404040;
    font-size: 26/100rem;
    font-weight: bold;
    line-height: 38/100rem;
    display: flex;
    align-items: center;
    min-height: 108/100rem;
    padding-left: 27/100rem;
    background: #ffffff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(239, 237, 237, 0.5);
    .logo {
      width: 48/100rem;
      height: 48/100rem;
      margin-right: 17/100rem;
    }
  }
  .vehicle-content {
    color: #404040;
    font-size: 24/100rem;
    // background-color: #f1f6f7;
    position: relative;
    z-index: 2;
    .vehicle-box {
      background-image: linear-gradient(to bottom, #fad11a, #f2f6f6);
      margin-top: -2/100rem;
      padding: 20/100rem 0;
      .vehicle-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 578/100rem;
        height: 273/100rem;
        // min-height: 273/100rem;

        background-image: linear-gradient(to bottom, #fdf6d7, #face0b);
        margin: auto;
        padding: 8/100rem;
        overflow: hidden;
        .vehicle-img {
          object-fit: contain;
          // width: 100%;
          // height: 100%;
          max-width: 100%;
          // width: 1;
          height: 100%;
        }
      }
    }
    .tip-info {
      line-height: 29/100rem;
      margin-left: 34/100rem;
    }
    .error-info {
      font-size: 20/100rem;
      color: #df2c2f;
      margin: 9/100rem 30/100rem 24/100rem 34/100rem;
    }
    .vehicle-info {
      display: flex;
      width: 100%;
      min-height: 179/100rem;
      background: url("https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/vehicle_show_bg.png")
        center center no-repeat;
      background-color: #fff;
      background-size: 98% 100%;
      .vehicle-icon {
        width: 94/100rem;
        height: 94/100rem;
        margin: 39/100rem 36/100rem 46/100rem 43/100rem;
      }
      .info-box {
        display: flex;
        flex-direction: column;
        width: 455/100rem;
        margin-top: 41/100rem;
        padding-right: 41/100rem;
        .vehicle-name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
          font-size: 36/100rem;
          line-height: 43/100rem;
          margin-bottom: 9/100rem;
        }
        .vegicle-code {
          line-height: 34/100rem;
        }
      }
    }
    .vehicle-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 104/100rem;
      margin-bottom: 170/100rem;
      .empty-img {
        width: 502/100rem;
        height: 244/100rem;
        margin: 0 69/100rem 5/100rem;
      }
      .txt {
        font-size: 27/100rem;
        color: #7e7e7e;
        line-height: 38/100rem;
      }
    }
  }
  .engine-displacement-list {
    display: flex;
    flex-direction: column;
    padding-left: 27/100rem;
    .subtitle {
      display: flex;
      margin: 34/100rem 0 17/100rem 0;
      color: #fbce07;
      font-size: 26/100rem;
      line-height: 0;
      align-items: center;
      font-weight: bold;
      .rect-icon {
        width: 26/100rem;
        height: 26/100rem;
        margin-right: 17/100rem;
      }
      .subtitle-text {
        line-height: 36/100rem;
        vertical-align: middle;
      }
      .blue-color {
        color: #b1e6ec;
      }
    }
    .engine-displacement-item {
      padding: 17/100rem 0;
      color: #404040;
      line-height: 36/100rem;
      font-size: 26/100rem;
      &:active {
        background: #f0f0f0;
      }
      &:last-child {
        margin-bottom: 40/100rem;
      }
    }
  }
  .footer-box {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 150/100rem;
    padding: 17/100rem 26/100rem 48/100rem;
    background-color: #fff;
    box-shadow: 0 2/100rem 8/100rem rgba(0, 0, 0, 0.1);
    .btn-l,
    .btn-r {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 282/100rem;
      height: 85/100rem;
      line-height: 85/100rem;
      font-size: 24/100rem;
      font-weight: bolder;
    }
    .btn-l {
      margin-right: 26/100rem;
      border: 2/100rem solid #fbce07;
      color: #fbce07;
    }
    .btn-r {
      border: 2/100rem solid #fbce07;
      background-color: #fbce07;
    }
  }
}
.ai-custom-pb {
  padding-bottom: 110/100rem;
  background: #f2f6f6;
}
.top-bg {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  height: 606/100rem;
  background-image: linear-gradient(to bottom, #f9e177, #f2f6f6);
}
</style>
